import React from 'react';
import Login from 'components/auth/Login';
import toast from 'react-hot-toast';
import { useRouter } from 'next/router';
import { useLocalStorage } from 'react-use';
import { loginRedirectStorageKey } from 'data/constants';
import { withGuestGuard } from 'components/auth/withGuestGuard';

const LoginPage = () => {
    const { push } = useRouter();
    const [loginRedirect, setLoginRedirect] = useLocalStorage(loginRedirectStorageKey, null);
    const handleLoginSuccess = (user) => {
        if (user && !user.completed_registration_at) {
            push('/zakljuci-registracijo');
        } else {
            if (loginRedirect) {
                push(loginRedirect);
                setLoginRedirect(null);
            } else {
                push('/profil');
            }
            toast.success(`Živjo ${user.first_name}, lepo da si nazaj.`, { duration: 5000, icon: '👋' });
        }
    };
    return (
        <div className="container max-w-md mx-auto pt-12 pb-24">
            <Login onLoginSuccess={handleLoginSuccess} />
        </div>
    );
};

export default withGuestGuard(LoginPage);
